import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThirdPartyAnimationHost } from './thirdPartyAnimationHost';
import { ThirdPartyAnimationVariant } from './thirdPartyAnimationVariant';
const ThirdPartyAnimationComponent = ({ ...props }, ref) => {
    if (props.variant) {
        return _jsx(ThirdPartyAnimationVariant, { ...props, ref: ref });
    }
    if (props.animation) {
        return _jsx(ThirdPartyAnimationHost, { ref: ref, ...props, animation: props.animation });
    }
    return null;
};
/**
 * @deprecated This component has been deprecated and will be removed in the next MAJOR release.
 *
 * ThirdPartyAnimation component is a component that can be used to create third-party animations.
 * @param {React.PropsWithChildren<IThirdPartyAnimation<V>>} props
 * @returns {JSX.Element}
 */
const ThirdPartyAnimation = React.forwardRef(ThirdPartyAnimationComponent);
export { ThirdPartyAnimation };
//# sourceMappingURL=thirdPartyAnimation.js.map